import { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchNode } from '@lumapps/wrex/serialization/html/fromHTML/utils';
import { getTextNodes } from '@lumapps/wrex/slate/utils/getTextNodes';

import { CODE_BLOCK } from '../../../constants';
import { createCodeBlock } from '../../../utils/createCodeBlock';

/**
 * HTML → slate conversion options for the code block element.
 */
export const ELEMENTS: { [CODE_BLOCK]: HTMLElementConvertOption<typeof CODE_BLOCK> } = {
    /**
     * Convert HTML `<pre>` into a slate code block element.
     */
    [CODE_BLOCK]: {
        test: matchNode({ tagName: 'pre' }),
        transform(_, children: any) {
            return createCodeBlock(getTextNodes(children));
        },
        type: CODE_BLOCK,
    },
};
